// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"47d81387","415":"47d81387","522":"47d81387","631":"d35bb7d7","720":"d35bb7d7"}[chunkId] + ".chunk.css";
};